import React from 'react';

function CostQuote() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>

      {/* HEADER HERO SECTION */}
      <header style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Compare Global Medical Tourism Costs: Request an Independent Treatment Estimate
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', maxWidth: '800px', margin: '0 auto' }}>
          Navigating international healthcare shouldn't involve financial ambiguity. Whether you are researching advanced cardiothoracic interventions, extensive multi-joint replacements, or oncology management regimes, comparing competitive pricing benchmarks helps you control your healthcare path safely.
        </p>
      </header>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', marginTop: '20px' }}>

        {/* LEFT COLUMN: THE INTERACTIVE ESTIMATE FORM */}
        <section style={{ 
          flex: '1', 
          minWidth: '280px', 
          background: '#fcfcfc', 
          border: '1px solid #e0e0e0', 
          padding: 'clamp(15px, 4vw, 25px)', 
          borderRadius: '4px',
          boxSizing: 'border-box'
        }}>
          <h2 style={{ color: '#0b3c5d', textAlign: 'center', marginBottom: '10px', fontSize: 'clamp(1.2rem, 4vw, 1.5rem)' }}>📋 Get a Free Multi-Hospital Cost Estimate</h2>
          <p style={{ color: '#666', textAlign: 'center', fontSize: '13.5px', marginBottom: '20px', lineHeight: '1.5' }}>
            Upload your health reports. Our medical team will analyze and provide 3 independent hospital quotes within 24 hours.
          </p>

          <form style={{ display: 'flex', flexDirection: 'column', gap: '15px' }} onSubmit={(e) => e.preventDefault()}>
            <input type="text" placeholder="Patient Full Name" style={{ padding: '12px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', width: '100%' }} required />
            <input type="email" placeholder="Email Address" style={{ padding: '12px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', width: '100%' }} required />
            <input type="tel" placeholder="Phone Number / WhatsApp" style={{ padding: '12px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', width: '100%' }} required />

            <select style={{ padding: '12px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', background: '#fff', boxSizing: 'border-box', width: '100%', maxWidth: '100%' }} required>
              <option value="">Select Treatment / Specialty</option>

              {/* Cardiology & Vascular */}
              <optgroup label="Cardiology & Heart Care">
                <option value="cardiology">Cardiology (Heart Bypass/CABG)</option>
                <option value="angioplasty">Angioplasty & Valves Treatment</option>
              </optgroup>

              {/* Orthopedics */}
              <optgroup label="Orthopedic Surgery">
                <option value="orthopedics">Orthopedics (Knee Joint Replacement)</option>
                <option value="hip-replacement">Hip Replacement Surgery</option>
              </optgroup>

              {/* Oncology & Hematology */}
              <optgroup label="Oncology & Blood Disorders">
                <option value="oncology">Oncology (Cancer Care)</option>
                <option value="bone-marrow">Bone Marrow Transplant</option>
              </optgroup>

              {/* Other Specialized Services */}
              <optgroup label="Other Specialties & Wellness">
                <option value="dental">Dental Packages & Surgery</option>
                <option value="ayurveda">Ayurveda, Yoga & Holistic Wellness</option>
                <option value="treatments">General Specialties & Treatments</option>
              </optgroup>

              {/* General Consultation */}
              <optgroup label="Consultation & Support">
                <option value="doctor-consultation">Doctor Consultation</option>
                <option value="medical-opinion">Get Medical Opinion</option>
                <option value="other">Other Medical Consultation</option>
              </optgroup>
            </select>

            <textarea placeholder="Describe patient medical history or condition briefly..." rows="4" style={{ padding: '12px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px', fontFamily: 'inherit', boxSizing: 'border-box', width: '100%' }}></textarea>

            <div style={{ background: '#fff', border: '1px dashed #bbb', padding: '15px', borderRadius: '4px', textAlign: 'center', fontSize: '0.9rem', color: '#666', cursor: 'pointer' }}>
              📎 <strong>Click to attach medical files</strong> (PDF, DICOM scans, or images)
            </div>

            <button type="submit" style={{ background: '#28a745', color: '#fff', border: 'none', padding: '14px', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px', transition: 'background 0.2s', width: '100%', boxSizing: 'border-box' }}>
              Submit Query Successfully
            </button>
          </form>
        </section>

        {/* RIGHT COLUMN: SEARCH DRIVER DATA CONTENT */}
        <div style={{ flex: '1.2', minWidth: '280px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '25px', boxSizing: 'border-box' }}>

          {/* COST REFERENCE TABLE - MADE RESPONSIVE */}
          <section style={{ width: '100%' }}>
            <h3 style={{ color: '#0b3c5d', margin: '0 0 10px 0', fontSize: 'clamp(1.2rem, 4vw, 1.4rem)' }}>Estimated Treatment Savings Matrix</h3>
            <p style={{ color: '#555', fontSize: '0.95rem', lineHeight: '1.5', margin: '0 0 15px 0' }}>
              Unregulated domestic health invoices frequently include surprise ancillary fees. Review standard, estimated out-of-pocket pricing averages tracked across prominent global surgical markets:
            </p>

            {/* Scroll Container Protection */}
            <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <table style={{ width: '100%', minWidth: '500px', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.9rem', color: '#333' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #ddd' }}>
                    <th style={{ padding: '8px' }}>Specialty Procedure</th>
                    <th style={{ padding: '8px' }}>US Systems</th>
                    <th style={{ padding: '8px' }}>UK Private</th>
                    <th style={{ padding: '8px', color: '#28a745' }}>Global Range</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '8px' }}><strong>Coronary Bypass (CABG)</strong></td>
                    <td style={{ padding: '8px' }}>$120,000+</td>
                    <td style={{ padding: '8px' }}>$70,000+</td>
                    <td style={{ padding: '8px', fontWeight: 'bold', color: '#28a745' }}>$6,500 - $9,000</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '8px' }}><strong>Total Knee Replacement</strong></td>
                    <td style={{ padding: '8px' }}>$35,000+</td>
                    <td style={{ padding: '8px' }}>$16,000+</td>
                    <td style={{ padding: '8px', fontWeight: 'bold', color: '#28a745' }}>$4,500 - $6,500</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '8px' }}><strong>Bone Marrow (Autologous)</strong></td>
                    <td style={{ padding: '8px' }}>$150,000+</td>
                    <td style={{ padding: '8px' }}>$70,000+</td>
                    <td style={{ padding: '8px', fontWeight: 'bold', color: '#28a745' }}>$15,000 - $22,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* SECURITY & DATA PROTECTION */}
          <section style={{ padding: '15px', background: '#fafafa', border: '1px solid #eee', borderRadius: '4px', boxSizing: 'border-box', width: '100%' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', display: 'flex', alignItems: 'center', gap: '6px' }}>🛡️ Privacy & Medical Data Encryption Standards</h4>
            <p style={{ margin: '0', fontSize: '0.85rem', color: '#666', lineHeight: '1.6' }}>
              We adhere strictly to international digital patient compliance frameworks. Your transmitted health histories, laboratory files, and contact coordinates are completely encrypted before transmission and are used for processing informational cost maps.
            </p>
          </section>

        </div>
      </div>

      {/* MANDATORY LEGAL SAFEGUARD EXCLUSION STATEMENT */}
      <section style={{ marginTop: '40px', borderTop: '1px solid #e5e5e5', paddingTop: '20px' }}>
        <h3 style={{ color: '#0b3c5d', fontSize: '1.1rem', margin: '0 0 8px 0', display: 'flex', alignItems: 'center', gap: '6px' }}>⚖️ Platform Data Policy & Legal Safeties</h3>
        <p style={{ color: '#777', fontSize: '0.85rem', lineHeight: '1.6', margin: '0', textAlign: 'left' }}>
          <strong>Medical Trip World functions exclusively as an open informational venue and independent directory reference.</strong> We do not issue formal clinical diagnoses, prescribe treatment coordinates, or execute legal medical contracts. Our system provides open estimation templates based on public healthcare cost registries and generic industry analysis. Medical Trip World does not maintain official commercial partnerships, legal associations, or active Memorandums of Understanding (MOUs) with any medical facility, clinic group, or hospital brand. All finalized medical expense contracts, diagnostic vetting checks, and clinical care obligations happen directly and exclusively between the patient and their selected healthcare provider.
        </p>
      </section>

    </article>
  );
}

export default CostQuote;